export default __webpack_public_path__ + "static/media/image034.a1376a9b.png";